var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{
    stuck: _vm.isStuck,
    'header--gradient': _vm.gradient,
    'header--fixed': _vm.fixed,
    'header--active': _vm.mobileNavActive,
  }},[_c('ContentContainer',{staticClass:"header__content-container"},[_c('div',{staticClass:"header__inner"},[_c('div',{staticClass:"header__brand header__brand--desktop"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/assets/images/brand/logo_compact.png"}})])],1),_c('div',{staticClass:"header__brand header__brand--mobile"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"/assets/images/brand/logo_compact.png"}})])],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }